import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@services/auth/auth.service';

export const noAuthGuard = () => {
	const authService = inject(AuthService);
	const router = inject(Router);

	/**
	 * Protects public routes from authenticated users.
	 * Redirects to a protected route if the user is authenticated.
	 */
	if (authService.isAuthenticated()) {
		router.navigate(['/dashboard']);
		return false;
	}

	return true;
};
